import FarbeTool from "../classes/class_farbetool";
import ToolOptionsFarbe from "./ToolOptionsFarbe.vue";

export let Farbe8 = new FarbeTool('farbe8', 'btn_farbe8', {
        AffectedElements: "w, pc",
        Overlap: true,
    },
    {
        mouseover: {
            Adjacent: true,
        },
        click: {
            Adjacent: false,
        },
    }, {

        Color: '#c74ee2',
        ColorLight: 'rgba(199, 78, 266, 0.5)',
        CssClass: 'farbe8',
        CssWhenActive: true,
        CssWhenOtherToolsActive: false,
        // box-shadows can be stacked on top of each other
        CssHover: `box-shadow: inset 0 -4px 0 0 rgba(199, 78, 266, 0.5);`,
        CssApplied: `box-shadow: inset 0 -4px 0 0 rgba(199, 78, 266, 1);`,
        CssClassHover: '',
        Cursor: 'custom',
        CursorURL: "/img/editor/cursors/ablabsmarker.png",
        Group: 3,
        Icon: "<img src='/img/svg/hermeneus-btn-farbe8.svg'>",
        Title: 'Farbe 8',
    }, {
        Description:
            `   
            <span class="hermeneus-editor__tool-description bold emphasize">Farbliche Markierung hinzufügen</span>`, Introduction: `
            Markieren Sie Wörter bei gedrückter Maustaste oder durch Klicken farblich. Mit Klick auf 'Fertig' speichern Sie Ihre Auswahl.`,
             ToolOptions:  ToolOptionsFarbe
    }, {
        attributes: {
            function: 'farbe8'
        },
        hierarchy: 3,
    });
